var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscribers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2295 27.0223H5.3651C4.13893 27.0223 3.26838 25.8275 3.64384 24.6602C4.64122 21.5592 7.69803 19.3151 11.1306 19.3151C12.7681 19.3151 14.2862 19.8258 15.5346 20.6965M14.8851 15.5421C16.2901 14.056 18.28 13.1287 20.4866 13.1287C22.124 13.1287 23.6422 13.6393 24.8905 14.5101M20.5756 26.3685L18.047 23.7035M27.9753 18.9884L20.5854 26.3782M7.4442 15.5816C7.4442 13.5348 9.10354 11.8754 11.1504 11.8754C13.1973 11.8754 14.8566 13.5348 14.8566 15.5816C14.8566 17.6285 13.1973 19.2878 11.1504 19.2878C9.10354 19.2878 7.4442 17.6285 7.4442 15.5816ZM16.8001 9.39518C16.8001 7.34831 18.4595 5.68896 20.5063 5.68896C22.5532 5.68896 24.2126 7.34831 24.2126 9.39518C24.2126 11.4421 22.5532 13.1014 20.5063 13.1014C18.4595 13.1014 16.8001 11.4421 16.8001 9.39518Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribers);
export default __webpack_public_path__ + "static/media/Subscribers.5c617d728d78fadc73e1372688aaba1f.svg";
export { ForwardRef as ReactComponent };